<template>
  <div>
    <a-form-model
      :label-width="data.config.labelWidth + 'px'"
      :labelWrap="data.config.labelPosition"
      :model="models"
      :rules="rules"
      :size="data.config.size"
      ref="generateForm"
    >
      <template v-for="item in data.list">
        <template v-if="item.type == 'grid'">
          <a-row
            :align="item.options.align"
            :gutter="item.options.gutter ? item.options.gutter : 0"
            :justify="item.options.justify"
            :key="item.key"
            type="flex"
          >
            <a-col :key="colIndex" :span="col.span" v-for="(col, colIndex) in item.columns">
              <template v-for="citem in col.list">
                <a-form-item :key="citem.key" :label="citem.name" :prop="citem.model" v-if="citem.type=='blank'">
                  <slot :model="models" :name="citem.model" />
                </a-form-item>
                <genetate-form-item
                  :data="data"
                  :key="citem.key"
                  :models.sync="models"
                  :preview="preview"
                  :prop-value="citem.model"
                  :remote="remote"
                  :widget="citem"
                  @input-change="onInputChange"
                  v-else
                />
              </template>
            </a-col>
          </a-row>
        </template>

        <template v-else-if="item.type == 'blank'">
          <a-form-item :key="item.key" :label="item.name" :prop="item.model">
            <slot :model="models" :name="item.model" />
          </a-form-item>
        </template>
        <!-- 子表单 -->
        <template v-else-if="item.type === 'subform'">
          <a-form-item
            :key="item.key"
            :label="!item.options.labelWidthStatus?'':item.name"
            :label-width="!item.options.labelWidthStatus?'0px': item.options.labelWidth + 'px'"
          >
            <a-table
              :data="models[item.model]"
              :header-cell-style="{padding: '5px 0'}"
              border
              size="mini"
              style="width: 100%"
            >
              <a-table-column fixed v-if="!preview" width="50">
                <template slot="header">
                  <i
                    @click="addSubformCol(item)"
                    class="el-icon-circle-plus"
                    style="font-size: 25px; color: #409EFF;cursor:pointer;"
                  />
                </template>
                <template slot-scope="scope">
                  <i
                    @click="delSubformCol(item, scope.$index)"
                    class="el-icon-remove"
                    style="font-size: 25px; color: red"
                  />
                </template>
              </a-table-column>
              <template v-for="(c, i) in item.columns">
                <div :key="i">
                  <a-table-column :key="v.key" :label="v.name" :prop="v.model" min-width="250" v-for="v in c.list">
                    <template slot-scope="scope">
                      <genetate-form-item
                        :data="data"
                        :disabled="disabled"
                        :is-label="false"
                        :models.sync="models"
                        :preview="preview"
                        :prop-value="item.model + '.' + scope.$index + '.' + v.model"
                        :remote="remote"
                        :subform-index="scope.$index"
                        :subform-model="item.model"
                        :widget="v"
                      />
                    </template>
                  </a-table-column>
                </div>
              </template>
            </a-table>
          </a-form-item>
        </template>

        <template v-else>
          <genetate-form-item
            :data="data"
            :disabled="disabled"
            :key="item.key"
            :models.sync="models"
            :preview="preview"
            :prop-value="item.model"
            :remote="remote"
            :widget="item"
            @input-change="onInputChange"
          />
        </template>
      </template>
    </a-form-model>
  </div>
</template>

<script>
  import GenetateFormItem from './GenerateFormItem'

  export default {
    name: 'FmGenerateForm',
    components: {
      GenetateFormItem
    },
    /* eslint-disable */
    props: ['data', 'remote', 'value', 'insite', 'disabled', 'preview'],
    data () {
      return {
        tableData: [],
        models: {},
        rules: {},
        subformFields: {}
      }
    },
    watch: {
      data: {
        deep: true,
        handler (val) {
          this.generateModle(val.list)
        }
      },
      value: {
        deep: true,
        handler (val) {
          this.models = { ...this.models, ...val }
        }
      }
    },
    created () {
      this.generateModle(this.data.list)
    },
    mounted () {
    },
    methods: {
      addSubformCol (item) {
        var subformFields = {}
        for (var c of item.columns) {
          for (var l of c.list) {
            if (l.options !== null && l.options !== undefined) {
              subformFields[l.model] = l.options.defaultValue !== undefined && l.options.defaultValue !== null ? l.options.defaultValue : ""
            } else {
              subformFields[l.model] = ""
            }

            if (this.rules[item.model] === undefined) {
              this.rules[item.model] = []
            }
            if (this.rules[item.model][this.models[item.model].length] === undefined) {
              this.rules[item.model][this.models[item.model].length] = {}
            }
            this.rules[item.model][this.models[item.model].length][l.model] = [...l.rules.map(item => {
              if (item.pattern) {
                return { ...item, pattern: eval(item.pattern) }
              } else {
                return { ...item }
              }
            })]
          }
        }
        this.models[item.model].push(subformFields)
        this.models.status = 1
      },
      delSubformCol (item, index) {
        this.models[item.model].splice(index, 1)
        this.models.status = -1
      },
      generateModle (genList) {
        for (let i = 0; i < genList.length; i++) {
          if (genList[i].type === 'grid') {
            genList[i].columns.forEach(item => {
              this.generateModle(item.list)
            })
          } else {
            if (this.value && Object.keys(this.value).indexOf(genList[i].model) >= 0) {
              this.models[genList[i].model] = this.value[genList[i].model]
            } else {
              if (genList[i].type === 'blank') {
                this.$set(this.models, genList[i].model, genList[i].options.defaultType === 'String' ? '' : (genList[i].options.defaultType === 'Object' ? {} : []))
              } if (genList[i].type === 'subform') {
                this.$set(this.models, genList[i].model, [])
              } else {
                this.models[genList[i].model] = genList[i].options.defaultValue
              }
            }

            if (!this.preview) {
              if (this.rules[genList[i].model]) {
                this.rules[genList[i].model] = [...this.rules[genList[i].model], ...genList[i].rules.map(item => {
                  if (item.pattern) {
                    return { ...item, pattern: eval(item.pattern) }
                  } else {
                    return { ...item }
                  }
                })]
              } else {
                this.rules[genList[i].model] = [...genList[i].rules.map(item => {
                  if (item.pattern) {
                    return { ...item, pattern: eval(item.pattern) }
                  } else {
                    return { ...item }
                  }
                })]
              }
            }
          }
        }
      },
      getData () {
        const that = this
        return new Promise((resolve, reject) => {
          that.$refs.generateForm.validate(valid => {
            if (valid) {
              resolve(that.models)
            } else {
              reject(new Error(that.$t('fm.message.validError')).message)
            }
          })
        })
      },
      reset () {
        this.$refs.generateForm.resetFields()
      },
      onInputChange (value, field) {
        // this.$emit('on-change', field, value, this.models)
      },
      refresh () {

      }
    }
  }
</script>

<style lang="less">
  // @import '../styles/cover.scss';
</style>
